import { DatabaseInfo } from "lib/types";
import { ReactNode, createContext, useState, useEffect } from "react";
import { getDatabasesList } from "pages/dashboard/database/service";
import { showToast } from "ui/components/common";
import { useSearchParams } from "react-router-dom";
import { set } from "date-fns";
type DatabaseContextType = {
  databases: DatabaseInfo[];
  setDatabases: (newState: DatabaseInfo[]) => void;
  isLoading: boolean;
  //setIsLoading: (newState: boolean) => void;
  queryDatabases: (append?: boolean) => Promise<void>;
};

const initialValue = {
  databases: [],
  setDatabases: () => {},
  queryDatabases: async () => {},
  isLoading: false,
  //setIsLoading: () => {},
};

export const DatabaseContext = createContext<DatabaseContextType>(initialValue);

export default function DatabaseProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [databases, setDatabases] = useState<DatabaseInfo[]>();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const query = searchParams.get("query") || "";

  useEffect(() => {
    setDatabases([]);
    setIsLoading(true);
    queryDatabases().then(() => {
      setIsLoading(false);
    });
  }, [query]);

  const queryDatabases = async (append: boolean = false) => {
    const response = await getDatabasesList(query);
    if (response.status !== 200) {
      showToast(1, "There was a problem fetching databases. Please try again.");
      return;
    }
    const data = response.data;
    if (append) {
      console.log("queryOrders", databases);
      setDatabases([...databases, ...(data.databases as DatabaseInfo[])]);
    } else {
      setDatabases(data?.databases);
    }
  };
  return (
    <DatabaseContext.Provider
      value={{
        databases,
        setDatabases,
        queryDatabases,
        isLoading,
      }}
    >
      {children}
    </DatabaseContext.Provider>
  );
}
